const selectors = {
    content: '[data-toc-content]',
    contentContainer: '[data-content-container]',
    scrollTo: '[data-scroll-to]',
    scrollToEl: (id) => `[data-scroll-id="${id}"]`,
    button: '[data-toggle-button]',
    wrap: '[data-toggle-wrap]',
    body: '[data-toggle-body]',
    open: '[data-toggle-open]',
    close: '[data-toggle-close]'
};

document.addEventListener('DOMContentLoaded', () => {
    renderContentListTable();
    setupEventListeners();
    observeTableOfContents();
});

function renderContentListTable() {
    const content = document.querySelector(selectors.content);
    if (!content) return;

    const titles = Array.from(content.children).filter(el => el.tagName === 'H2' || el.tagName === 'H3');
    if (!titles.length) return;

    const contentList = createContentList(titles);
    const contentContainer = content.querySelector(selectors.contentContainer);

    contentContainer ? contentContainer.append(contentList) : content.prepend(contentList);
}

function createContentList(titles) {
    const contentListWrapper = document.createElement("div");
    const contentListBody = document.createElement("div");
    const contentList = document.createElement("div");
    const contentListHeader = document.createElement("header");

    contentListWrapper.classList.add('table-of-contents__wrapper');
    contentListBody.setAttribute('data-toggle-body', '');
    contentListBody.classList.add('table-of-contents__body', 'active');
    contentList.classList.add('table-of-contents', 'active');
    contentList.setAttribute('data-toggle-wrap', '');
    contentList.setAttribute('data-content-list', '');
    contentListHeader.setAttribute('data-content-header', '');
    contentListHeader.classList.add('table-of-contents__header');
    contentListHeader.innerHTML = `
        <h3>Table of contents</h3>
        <button data-toggle-hide="Hide" data-toggle-open="Open" data-toggle-button class="button button--transparent button--small active">
            <span>Hide</span>    
            <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.70292 6.99976L5.5 2.67137L1.29708 6.99976L0 5.66395L5.5 -0.000244141L11 5.66395L9.70292 6.99976Z" fill="#C19C64"/>
            </svg>
        </button>`;

    contentListWrapper.append(contentListHeader, contentListBody);
    contentList.append(contentListWrapper);

    let html = '<ul class="table-of-contents__list">';
    let firstIndex = titles.findIndex(el => el.tagName === 'H2');

    if (firstIndex > -1) {
        for (let i = firstIndex + 1; i <= titles.length; i++) {
            if (i === titles.length || titles[i].tagName === 'H2') {
                titles[firstIndex].id = `heading-${firstIndex}`;
                html += `
                    <li class="table-of-contents__list-item">
                        <a href="#heading-${firstIndex}">${titles[firstIndex].innerText}</a>
                        ${renderInnerElement(titles.slice(firstIndex + 1, i), firstIndex)}
                    </li>`;
                firstIndex = i;
            }
        }
        html += '</ul>';
        contentListBody.innerHTML = html;
    }

    return contentList;
}

function renderInnerElement(temporary, i) {
    const subtitles = temporary.filter(el => el.tagName === 'H3');
    if (!subtitles.length) return '';

    return `
        <div class="table-of-contents__dropdown">
            <ul>
                ${subtitles.map((el, index) => {
        el.setAttribute('data-scroll-id', `${i}-${index}`);
        return `<li><a data-scroll-to="${i}-${index}" href="#">${el.innerText}</a></li>`;
    }).join('')}
            </ul>
        </div>`;
}

function toggleElement(element) {
    const open = element.getAttribute('data-toggle-open');
    const close = element.getAttribute('data-toggle-hide');
    const wrap = element.closest(selectors.wrap);
    const body = wrap ? wrap.querySelector(selectors.body) : null;
    const text = element.querySelector('span');

    element.classList.toggle('active');
    if (wrap) wrap.classList.toggle('active');
    if (body) body.classList.toggle('active');
    if (text) text.innerText = element.classList.contains('active') ? close : open;
}

function setupEventListeners() {
    document.addEventListener('click', event => {
        const { target } = event;

        if (target.matches(selectors.scrollTo)) {
            event.preventDefault();
            scrollToElement(target);
        }

        if (target.matches(`${selectors.button}, ${selectors.button} *`)) {
            event.preventDefault();
            const element = target.matches(selectors.button) ? target : target.closest(selectors.button);
            toggleElement(element);
        }
    });

    let lastScrollPos = window.scrollY;
    window.addEventListener('scroll', () => {
        lastScrollPos = window.scrollY;
    });

    document.querySelectorAll('.table-of-contents__list a').forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            smoothScrollToSection(link, lastScrollPos);
        });
    });
}

function scrollToElement(target) {
    const id = target.getAttribute('data-scroll-to');
    const scrollToEl = document.querySelector(selectors.scrollToEl(id));
    const contentListHeader = document.querySelector('[data-content-header]');
    const offset = window.innerWidth < 1450 ? (contentListHeader ? contentListHeader.offsetHeight + 250 : 0) : 0;

    if (scrollToEl) {
        window.scrollTo({
            top: scrollToEl.offsetTop - offset,
            behavior: 'smooth'
        });
    }
}

function smoothScrollToSection(link, lastScrollPos) {
    const href = link.getAttribute('href');
    const target = document.querySelector(href);

    if (target) {
        const targetOffset = target.getBoundingClientRect().top + window.scrollY;
        const offset = lastScrollPos > targetOffset ? 140 : 0;

        window.scrollTo({
            top: targetOffset - offset,
            behavior: 'smooth'
        });
    }
}

function observeTableOfContents() {
    const contentList = document.querySelector('.table-of-contents');
    if (!contentList) return;

    const initialHeight = contentList.getBoundingClientRect().height;
    contentList.style.height = `${initialHeight}px`;

    let hasEntered = false;
    let intersectionY = 0;
    let stickyAddedAtY = 0;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !hasEntered) {
                hasEntered = true;
                intersectionY = entry.boundingClientRect.top + window.scrollY;
            } else if (!entry.isIntersecting && hasEntered) {
                if (window.scrollY < intersectionY) {
                    contentList.classList.remove('sticky');
                    hasEntered = false;
                } else {
                    if (!contentList.classList.contains('sticky')) {
                        contentList.classList.add('sticky');
                        stickyAddedAtY = window.scrollY;
                    }
                }
            }
        });
    }, { threshold: 0 });

    const checkIfShouldBeSticky = () => {
        const boundingRect = contentList.getBoundingClientRect();
        const intersectionTop = boundingRect.top + window.scrollY;
        if (window.scrollY >= intersectionTop) {
            contentList.classList.add('sticky');
            stickyAddedAtY = window.scrollY;
        }
    };

    window.addEventListener('scroll', () => {
        if (contentList.classList.contains('sticky') && window.scrollY < stickyAddedAtY) {
            contentList.classList.remove('sticky');
        }
        checkIfShouldBeSticky(); // Check on every scroll event as well
    });

    checkIfShouldBeSticky(); // Check on initial load
    observer.observe(contentList); // Set up the observer
}
